 import React, { createContext, useContext, useState } from "react";
/*
// Create context
const BusinessContext = createContext(null);

// Create provider component
export const BusinessProvider = ({ children }) => {
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);

  return (
    <BusinessContext.Provider
      value={{ selectedBusinessId, setSelectedBusinessId }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

// Custom hook to use business context
export const useBusinessContext = () => {
  return useContext(BusinessContext);
};

// Create context
const BusinessTypeContext = createContext(null);

// Create provider component
export const BusinessTypeProvider = ({ children }) => {
  const [selectedBusinessTypeId, setSelectedBusinessTypeId] = useState(null);

  return (
    <BusinessTypeContext.Provider
      value={{ selectedBusinessTypeId, setSelectedBusinessTypeId }}
    >
      {children}
    </BusinessTypeContext.Provider>
  );
};

// Custom hook to use business context
export const useBusinessTypeContext = () => {
  return useContext(BusinessTypeContext);
};
 */
 // Create Context
const BusinessContext = createContext<any>(null);
 
// Combined Provider Component
export const BusinessProvider = ({ children }) => {
  // Business State
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);

  // Business Type State
  const [selectedBusinessTypeId, setSelectedBusinessTypeId] = useState(null);

  // Business Name State
  const [selectedBusinessName, setSelectedBusinessName] = useState(null);

    // Business Name State
    const [selectedBusinessTypeName, setSelectedBusinessTypeName] = useState(null);

    const [selectedRoleID, setSelectedRoleID] = useState(null);

    const [selectedRoleName, setSelectedRoleName] = useState(null);
    const [selectedBusiness, setSelectedBusiness] = useState(null);

  return (
    <BusinessContext.Provider value={{ 
      selectedBusinessId, setSelectedBusinessId, 
      selectedBusinessTypeId, setSelectedBusinessTypeId, 
      selectedBusinessName, setSelectedBusinessName ,
      selectedBusinessTypeName, setSelectedBusinessTypeName,
      selectedRoleID, setSelectedRoleID,
      selectedRoleName, setSelectedRoleName,
      selectedBusiness, setSelectedBusiness
    }}>
      {children}
    </BusinessContext.Provider>
  );
};

// Custom hooks to access contexts
export const useBusinessContext = () => useContext(BusinessContext);

